import {
  Timeline as MuiTimeline,
  TimelineConnector,
  TimelineContent,
  TimelineItem,
  timelineItemClasses,
  TimelineSeparator,
} from '@mui/lab';
import { Avatar, Box } from '@mui/material';
import { JSX } from 'react';

import { sapStatus, ThemaFromThemaRouter } from '../../dtos.ts';
import { elevateColorPalette } from '../../theme/colorPalette.ts';
import { Modultermin } from './DurchgangDetailsPage.types.ts';
import { ModulterminCard } from './ModulterminCard.tsx';

type Props = {
  modultermine: Modultermin[];
  thema: ThemaFromThemaRouter;
};

export const DurchgangOverview = ({ modultermine, thema }: Props) => {
  const items = modultermine.map((termin) => getTimelineDotAndContentForModultermin(termin, thema));

  return (
    <MuiTimeline
      sx={{
        padding: 0,
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 0,
        },
      }}
    >
      {items.map((item, index) => (
        // eslint-disable-next-line @eslint-react/no-array-index-key
        <TimelineItem key={index}>
          <TimelineSeparator sx={{ transform: 'translateY(20px)' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '28px',
                height: '28px',
                borderRadius: '999px',
                border: (theme) => `1px solid ${theme.palette.border.emphasised}`,
              }}
            >
              {item.dot}
            </Box>
            {index < items.length - 1 && (
              <TimelineConnector sx={{ width: '1px', background: (theme) => theme.palette.border.emphasised }} />
            )}
          </TimelineSeparator>
          <TimelineContent>{item.content}</TimelineContent>
        </TimelineItem>
      ))}
    </MuiTimeline>
  );
};

function getTimelineDotAndContentForModultermin(
  modultermin: Modultermin,
  thema: ThemaFromThemaRouter,
): {
  dot: JSX.Element;
  content: JSX.Element;
} {
  const color =
    modultermin.sapStatus === sapStatus.ABGESAGT
      ? elevateColorPalette.text.disabledSolid
      : elevateColorPalette.text.primary;

  return {
    dot: (
      <Avatar
        sx={{
          width: 28,
          height: 28,
          bgcolor: elevateColorPalette.surface.background,
          color,
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: elevateColorPalette.border.active,
          fontSize: '1rem',
        }}
        variant="circular"
      >
        {modultermin.modul.modulnummer}
      </Avatar>
    ),
    content: <ModulterminCard modultermin={modultermin} thema={thema} />,
  };
}
